module.exports = __webpack_public_path__ + "static/media/protects.7862c990.mp3";